// 护工端路由组件
import login from '@/components/login'
import password from '@/components/password'
import home from '@/components/home'
import main from '@/components/main'
import nursingIndex from '@/components/nursing/index'
import nursingOne from '@/components/nursing/nursing-one'
import nursingOneImplement from '@/components/nursing/nursing-one-implement'
import nursingBatch from '@/components/nursing/nursing-batch-implement'
import implementHistory from '@/components/implement-history'
import nursingHistory from '@/components/nursing/history'
import photo from '@/components/photo'
import shift from '@/components/shiftExchange/shift'
import nurseShiftExchange from '@/components/shiftExchange/nurseShiftExchange'
import floorShift from '@/components/shiftExchange/floorShift'
import shiftExchangeDetails from '@/components/shiftExchange/shiftExchangeDetails'
import addShift from '@/components/shiftExchange/addShift'
import record from '@/components/record/index'
import recordDetail from '@/components/record/detail'
import Physicalrecord from '@/components/Physicalrecord/index'
import alartRecord from '@/components/alartRecord/index'
import assessment from '@/components/assessment/index'
import topic from '@/components/assessment/topic'
import report from '@/components/assessment/report'
import mealsPlan from '@/components/mealsPlan/index'
import userList from '@/components/mealsPlan/userList'
import food from '@/components/food/index'
import leave from '@/components/leave/index'
import addLeave from '@/components/leave/add'
import medicine from '@/components/medicine/index'
import cure from '@/components/cure/index'
const router = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '',
    name: 'home',
    component: home,
    children: [
      {
        path: '/login',
        name: 'login',
        meta: {
          title: '登录',
          headIcon: false
        },
        component: login
      },
      {
        path: '/password',
        name: 'password',
        meta: {
          title: '找回密码',
          headIcon: true
        },
        component: password
      },
      {
        path: 'main',
        name: 'main',
        meta: {
          title: '主页',
          headIcon: false
        },
        component: main
      },
      {
        path: 'nursing',
        name: 'nursingIndex',
        component: nursingIndex,
        children: [
          {
            path: 'one',
            name: 'nursingOne',
            meta: {
              title: '长者护理'
            },
            component: nursingOne
          },
          {
            path: 'one/implement',
            name: 'nursingOneImplement',
            meta: {
              title: '长者护理'
            },
            component: nursingOneImplement
          },
          {
            path: 'batch/implement',
            name: 'nursingBatch',
            meta: {
              title: '长者护理'
            },
            component: nursingBatch
          },
          {
            path: 'history',
            name: 'nursingHistory',
            meta: {
              title: '长者护理'
            },
            component: nursingHistory
          }
        ]
      },
      {
        path: '/implementHistory',
        name: 'implementHistory',
        meta: {
          title: '最近输入'
        },
        component: implementHistory
      },
      {
        path: '/photo',
        name: 'photo',
        meta: {
          title: '幸福相册',
          headIcon: true
        },
        component: photo
      },
      {
        path: 'shift',
        component: shift,
        children: [
          {
            path: '/shiftExchange/nurseShiftExchange',
            name: 'nurseShiftExchange',
            meta: {
              title: '护士交班',
              headIcon: true,
              goHome: true
            },
            component: nurseShiftExchange
          },
          {
            path: '/shiftExchange/floorShift',
            name: 'floorShift',
            meta: {
              title: '楼层交班',
              headIcon: true,
              goHome: true
            },
            component: floorShift
          },
          {
            path: '/shiftExchange/shiftExchangeDetails',
            name: 'shiftExchangeDetails',
            meta: {
              title: '交班详情',
              headIcon: true
            },
            component: shiftExchangeDetails
          }
        ]
      },
      {
        name: 'record',
        path: '/record',
        meta: {
          title: '医疗档案'
        },
        component: record
      },
      {
        name: 'detail',
        path: '/record/detail',
        meta: {
          title: '医疗档案明细'
        },
        component: recordDetail
      },
      {
        name: 'Physicalrecord',
        path: '/Physicalrecord',
        meta: {
          title: '体征记录'
        },
        component: Physicalrecord
      },
      {
        name: 'alartRecord',
        path: '/alartRecord',
        meta: {
          title: '报警记录'
        },
        component: alartRecord
      },

      {
        path: '/shiftExchange/addShift',
        name: 'addShift',
        meta: {
          title: '新增交班',
          headIcon: true
        },
        component: addShift
      },
      {
        path: '/assessment/index',
        name: 'assessment',
        meta: {
          title: '评估',
          headIcon: true
        },
        component: assessment
      },
      {
        path: '/assessment/topic',
        name: 'topic',
        meta: {
          title: '评估',
          headIcon: true
        },
        component: topic
      },
      {
        path: '/assessment/report',
        name: 'topic',
        meta: {
          title: '评估报告',
          headIcon: true
        },
        component: report
      },
      {
        path: '/mealsPlan/userList',
        name: 'userList',
        meta: {
          title: '膳食计划',
          headIcon: true
        },
        component: userList
      },
      {
        path: '/mealsPlan/index',
        name: 'mealsPlan',
        meta: {
          title: '膳食计划',
          headIcon: true
        },
        component: mealsPlan
      },
      {
        path: '/food/index',
        name: 'food',
        meta: {
          title: '膳食计划',
          headIcon: true
        },
        component: food
      },
      {
        path: '/leave/index',
        name: 'leave',
        meta: {
          title: '暂离院',
          headIcon: true
        },
        component: leave
      },
      {
        path: '/leave/add',
        name: 'addLeave',
        meta: {
          title: '暂离院',
          headIcon: true
        },
        component: addLeave
      },
      {
        path: '/medicine',
        name: 'medicine',
        meta: {
          title: '服药',
          headIcon: true
        },
        component: medicine
      },
      {
        path: '/cure',
        name: 'cure',
        meta: {
          title: '治疗',
          headIcon: true
        },
        component: cure
      }
      // {
      //   path: '/shiftExchange/floorShift',
      //   name:'floorShift',
      //   meta:{
      //     title:'楼层交班',
      //     headIcon:true
      //   },
      //   component: floorShift,
      // },
      // {
      //   path: '/shiftExchange/shiftExchangeDetails',
      //   name:'shiftExchangeDetails',
      //   meta:{
      //     title:'交班详情',
      //     headIcon:true
      //   },
      //   component: shiftExchangeDetails,
      // },
    ]
  }
]
export default router



// WEBPACK FOOTER //
// ./src/router/data/nurse.js